module.exports = __webpack_public_path__ + "static/media/HCMM825.333cd575.jpg";